import { createAsyncThunk } from '@reduxjs/toolkit';
import callApi from '../../utils/api/callAPI';

/**
 * Gọi API lấy danh sách địa chỉ
 */
export const fetchDefaultPriceConfig = createAsyncThunk(
  'get/products/v3/products/default_setting',
  async ({ country_code = 'vn' }, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'products/v3/products/default_setting',
        method: 'get',
        params: {
          country_code,
        },
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response.result?.data || {},
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
    }
  }
);
